import { render, staticRenderFns } from "./MonthlyAssessScore.vue?vue&type=template&id=38cc0480&"
import script from "./MonthlyAssessScore.vue?vue&type=script&lang=js&"
export * from "./MonthlyAssessScore.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyAssessScore.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports